import type { ApiClient, IApiJsonRequest } from '../../ApiClient';
import type {
  IApiGetOnboardingStatusRequestBody,
  IApiGetOnboardingStatusResponseBody,
} from './OnboardingApi.types';

export class OnboardingApi {
  public constructor(private client: ApiClient) {}

  public async getStatus(
    params: IApiGetOnboardingStatusRequestBody,
  ): Promise<IApiGetOnboardingStatusResponseBody> {
    const request: IApiJsonRequest = {
      path: '/onboarding',
      method: 'get',
      params,
    };

    const data =
      await this.client.fetchJsonStandardized<IApiGetOnboardingStatusResponseBody>(
        request,
      );

    return data;
  }
}
